/**
 * @desc: - 倒计时框
 * @param  {[NUMBER]} current: [当前时间]
 * @param  {[NUMBER]} nex: [下一个时间]
 * @author: ammo
 */
import ReactDOM from 'react-dom';

export default class TimeBox extends React.Component {

  constructor(props) {
    super(props);
    this.makeTimeFormat = this.makeTimeFormat.bind(this);
    this.state = {
      current: ['--','--','--'],
      next: ['--','--','--']
    }
  }

  componentDidMount() {
   this.makeTimeFormat(this.props.current, this.props.interval);
  }

  componentWillReceiveProps(nextProps){
    if (this.props.current == nextProps.current) {
      return;
    }
    if (this.timer) {window.clearInterval(this.timer); this.timer = null;}
    this.makeTimeFormat(nextProps.current, nextProps.interval);
  }

  componentWillUnmount(){
    // 销毁定时器
    if (this.timer) {window.clearInterval(this.timer); this.timer = null;}
    if (this.setTimeout){window.clearTimeout(this.setTimeout); this.setTimeout = null;} 
  }

  // 生成时间
  makeTimeFormat(current, interval){
    if (current < 0) {
      current = interval + current;
    }
    const { request, soundPlay, soundFn, stopSoundFn } = this.props;
    if (_.isUndefined(current) || current == null) {
      this.setState({
        current: ['--','--','--'],
        next: ['--','--','--']
      })
      return;
    }

    if (current == interval) {
      current --;
    }
    this.setState({
      current: _.split($.formatTime(current), ':'),
      next: _.split($.formatTime(current == 0 ? interval-1 : current-1), ':')
    })

    this.current = current;
    if (current == 0 && request) {
      window.setTimeout(() => request(true), 500);
    }
    
    // 倒计时声音
    if(soundFn){
      if (current >= 0 && current < 10) {
        soundFn();
      }else if(soundPlay){
        stopSoundFn();
      }
    }

    if (this.timer) {return;}
    this.timer = window.setInterval(function(){
      this.makeTimeFormat(this.current == 0 ? interval -1  : this.current -1, interval);
    }.bind(this), 1000)

  }

  render() {
    let {current} = this.state;
    return (
      <div className={this.props.className + " lottery_timeBox left"}>
          <b>{current.slice(0,1) +':'+ current.slice(1,2) +':'+ current.slice(2,3)}</b>
        {/*<EachTimeBox current={this.state.current[0]} next={this.state.next[0]} index='0' hasDou={this.props.className == 'smallTime'?"has":""} />*/}
        {/*<EachTimeBox current={this.state.current[1]} next={this.state.next[1]} index='1' hasDou={this.props.className == 'smallTime'?"has":""} />*/}
        {/*<EachTimeBox current={this.state.current[2]} next={this.state.next[2]} index='2' />*/}
      </div>
    );
  }
}


class EachTimeBox extends React.Component {

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps){
    if (this.props.current == nextProps.current) {
      return;
    }
    if (this.props.next == nextProps.next) {
      return;
    }
    this.transL = false;
    this.transR = false;
    if (nextProps.current.split('')[0] != nextProps.next.split('')[0]) {
      this.transL = true;
    }
    if (nextProps.current.split('')[1] != nextProps.next.split('')[1]) {
      this.transR = true;
    }
    ReactDOM.findDOMNode( this.refs.current_num ).setAttribute('class', 'current_num');
    ReactDOM.findDOMNode( this.refs.next_num ).setAttribute('class', 'next_num');
  }

  shouldComponentUpdate(nextProps, nextState){
    if (this.props.current == nextProps.current && this.props.next == nextProps.next) {
      return false;
    }
    return true;
  }

  componentDidUpdate(){
    window.setTimeout(function(){
      if (this.transR && this.refs.rightBox) {
        ReactDOM.findDOMNode( this.refs.current_num ).setAttribute('class', 'current_num move');
        ReactDOM.findDOMNode( this.refs.next_num ).setAttribute('class', 'next_num move');
      }
    }.bind(this), 700)
  }

  render(){
    const {current, next, index} = this.props;
    return (
      <div className="time-box">
        <div className="timeBox">
          <div className="next_num" ref="next_num">
            <div ref='leftBox' className='num_left'>
              {next.split('')[0]}
            </div>
            <div ref='rightBox' className='num_right'>
              {next.split('')[1]}
            </div>
          </div>
          <div className="current_num" ref="current_num">
            <div ref='leftBox' className='num_left'>
              {current.split('')[0]}
            </div>
            <div ref='rightBox' className='num_right'>
              {current.split('')[1]}
            </div>
          </div>
        </div>
        <span>:</span>
      </div>
    )
  }

}